export enum SchemeTypeEnum {
  single_spore_citizen = "ssc",
  single_mother = "sm",
  joint_single_schema = "jss",
  orphan = "or",
  singapore_citizen_nucleus = "scn",
  bal_parent = "jt",
  public_applicant = "pa",
  non_citizen_family = "ncf",
  non_citizen_spouse = "ncs",
  orphan_sibling_scheme = "osc"
}
